import { UserProfileGetters } from './partials/user-profile'

export const UserGetters = {
  ...UserProfileGetters,
}
